import { render } from "./Registrant.vue?vue&type=template&id=e7d9bfc8"
import script from "./Registrant.vue?vue&type=script&lang=js"
export * from "./Registrant.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__